(function () {
  'use strict';

  var cartDrawer = document.getElementById('CartDrawer');
  var cartDrawerBody = document.getElementById('CartDrawerBody');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function fetchCart() {
    return fetch(window.routes.cart_url + '?section_id=cart-drawer', {
      headers: { 'Accept': 'text/html' }
    }).then(function (r) { return r.text(); });
  }

  function renderCart(html) {
    if (cartDrawerBody) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newContent = doc.querySelector('#CartDrawerBody');
      if (newContent) {
        cartDrawerBody.innerHTML = newContent.innerHTML;
      } else {
        cartDrawerBody.innerHTML = html;
      }
    }
    updateCartCount();
  }

  function updateCartCount() {
    fetch(window.routes.cart_url + '.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCountEls.forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  /* Quick add from product cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return fetchCart();
      })
      .then(function (html) {
        renderCart(html);
        openCartDrawer();
        btn.disabled = false;
      })
      .catch(function () {
        btn.disabled = false;
      });
  });

  /* Add to cart from product form */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var formData = new FormData(form);
    var variantId = formData.get('id');
    var qty = formData.get('quantity') || 1;

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: parseInt(qty, 10) })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return fetchCart();
      })
      .then(function (html) {
        renderCart(html);
        openCartDrawer();
      })
      .catch(function () {});
  });

  /* Buy it now - redirect to checkout */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-buy-now-form]');
    if (!form) return;
    e.preventDefault();

    var formData = new FormData(form);
    var variantId = formData.get('id');
    var qty = formData.get('quantity') || 1;

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: parseInt(qty, 10) })
    })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {});
  });

  /* Cart drawer quantity controls */
  cartDrawerBody.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('[data-quantity-minus]');
    var plusBtn = e.target.closest('[data-quantity-plus]');
    var removeBtn = e.target.closest('[data-cart-remove]');

    if (minusBtn) {
      var line = minusBtn.getAttribute('data-line');
      var input = cartDrawerBody.querySelector('[data-quantity-input][data-line="' + line + '"]');
      if (input) {
        var val = parseInt(input.value, 10) - 1;
        if (val < 1) val = 0;
        updateLine(line, val);
      }
    }
    if (plusBtn) {
      var line2 = plusBtn.getAttribute('data-line');
      var input2 = cartDrawerBody.querySelector('[data-quantity-input][data-line="' + line2 + '"]');
      if (input2) {
        var val2 = parseInt(input2.value, 10) + 1;
        updateLine(line2, val2);
      }
    }
    if (removeBtn) {
      var line3 = removeBtn.getAttribute('data-line');
      updateLine(line3, 0);
    }
  });

  /* Manual input change */
  cartDrawerBody.addEventListener('change', function (e) {
    var input = e.target.closest('[data-quantity-input]');
    if (!input) return;
    var line = input.getAttribute('data-line');
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 0) val = 0;
    updateLine(line, val);
  });

  function updateLine(line, quantity) {
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function () { return fetchCart(); })
      .then(function (html) { renderCart(html); })
      .catch(function () {});
  }

  /* Cart page quantity controls */
  var cartPageForm = document.querySelector('[data-cart-page-form]');
  if (cartPageForm) {
    cartPageForm.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('[data-cart-qty-minus]');
      var plusBtn = e.target.closest('[data-cart-qty-plus]');
      if (minusBtn) {
        var line = minusBtn.getAttribute('data-line');
        var input = cartPageForm.querySelector('[data-cart-qty-input][data-line="' + line + '"]');
        if (input) {
          input.value = parseInt(input.value, 10) - 1;
          if (input.value < 1) input.value = 0;
          submitCartPageChange(line, parseInt(input.value, 10));
        }
      }
      if (plusBtn) {
        var line2 = plusBtn.getAttribute('data-line');
        var input2 = cartPageForm.querySelector('[data-cart-qty-input][data-line="' + line2 + '"]');
        if (input2) {
          input2.value = parseInt(input2.value, 10) + 1;
          submitCartPageChange(line2, parseInt(input2.value, 10));
        }
      }
    });
  }

  function submitCartPageChange(line, quantity) {
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {});
  }

  /* Init cart count on load */
  updateCartCount();
})();
